export const environment = {
  production: false,
  environmentName: 'Développement',

  /**
   * URL absolue du serveur d'identité (KeepControlWeb.Front, endpoint OpenIddict /connect/token).
   * TOUJOURS absolue, jamais relative : le cookie HttpOnly de refresh est émis par le domaine de
   * Front (SameSite=Strict) et doit repartir vers lui.
   */
  authBaseUrl: 'https://192.168.3.120:5001',

  /** URL de base de l'API OnlineLifecycle (vide = même origine que la SPA). */
  apiBaseUrl: '',

  /**
   * Lien profond ouvrant la fiche d’un équipement dans l’application mobile Keep Control.
   *
   * `{url}` reçoit l’URL complète de la fiche (encodée), `{segment}` le seul segment chiffré.
   * C’est l’URL que le mobile exploite : elle désigne le jeu de clés de déchiffrement, comme
   * pour un QR code scanné.
   *
   * Le schéma est celui que déclare la saveur KCtest (fr.sds.keepcontrol2.test) dans son
   * AndroidManifest et son Info.plist : un téléphone portant plusieurs saveurs ouvre la bonne.
   * Une version de l’application antérieure à ce lien ne répond pas : le visiteur est alors
   * envoyé sur la fiche du magasin d’applications. Chaîne vide = bouton masqué.
   */
  mobileAppEpiUrl: 'keepcontrol-fr.sds.keepcontrol2.test://epi?url={url}',

  /**
   * Fiches des magasins d'applications, proposées quand l'application ne répond pas au lien.
   * Mêmes adresses que les courriels d'attribution de KeepControlWeb.Front.
   */
  mobileAppStoreUrls: {
    android: 'https://play.google.com/store/apps/details?id=fr.sds.keepcontrol2&hl=fr',
    ios: 'https://apps.apple.com/fr/app/keep-control/id6475165654',
  },
};
